import loader from "./loader";

window.googletag = window.googletag || { cmd: [] };

const load = loader(() => {
    let d = document;
    let g = d.createElement("script");
    let s = d.getElementsByTagName("script")[0];
    g.type = "text/javascript";
    g.src = "https://securepubads.g.doubleclick.net/tag/js/gpt.js";
    s.parentNode.insertBefore(g, s);
});

export default function (...args) {
    load();
    window.googletag.cmd.push(...args);
}
